import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var dropdownFixedArea = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_nxr8v71',variantClassNames:{side:{top:'fx_2d2fb1e5_nxr8v72',bottom:'fx_2d2fb1e5_nxr8v73'}},defaultVariants:{},compoundVariants:[]});

export { dropdownFixedArea };
//# sourceMappingURL=fixedArea.vanilla.mjs.map
